import React from 'react';
import { Table } from 'semantic-ui-react';

// Components
// @ts-ignore
import TableHeadTableCell from 'components/TableHeadTableCell';

const DocumentSetsTableHead = () => {
    return (
        <Table.Header
            // HACK inline styles
            style={{
                fontSize: 14
            }}
        >
            <Table.Row>
                <TableHeadTableCell
                    label="Created On"
                    value="createdAt"
                    defaultSort="createdAt_descending"
                />
                <TableHeadTableCell
                    label="Job Type"
                    value="schemaName"
                    defaultSort="createdAt_descending"
                />
                <Table.HeaderCell
                    className="events-table-cell-padding"
                    style={{ cursor: 'auto' }}
                >
                    Area Hierarchy
                </Table.HeaderCell>
                <TableHeadTableCell
                    label="Area"
                    value="entityName"
                    defaultSort="createdAt_descending"
                />
                <TableHeadTableCell
                    label="Variety"
                    value="varietyName"
                    defaultSort="createdAt_descending"
                />
                <TableHeadTableCell
                    label="Group"
                    value="groupName"
                    defaultSort="createdAt_descending"
                />
                <TableHeadTableCell
                    label="Start Date"
                    value="startDate"
                    defaultSort="createdAt_descending"
                />
                <TableHeadTableCell
                    label="End Date"
                    value="endDate"
                    defaultSort="createdAt_descending"
                />
                <TableHeadTableCell
                    label="Progress"
                    value="jobState"
                    defaultSort="createdAt_descending"
                />
                <Table.HeaderCell
                    className="events-table-cell-padding"
                    style={{ cursor: 'auto' }}
                >
                    Assignees
                </Table.HeaderCell>
                <Table.HeaderCell />
            </Table.Row>
        </Table.Header>
    );
};

export default DocumentSetsTableHead;
